import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _BudgetSource } from "../../../core/services/dataBean/EntityCatalogVdos";
import { ListMenu } from "../../theme/Component/ListMenu";
import { _AdquisitionItemBudgetID, _single } from "../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { SelectBudgetID } from "../../admin/configuracion/BudgetID/SelectBudgetID";
import { InputMoney } from "../../theme/Input/InputMoney";
import { SelectBudgetResourceForYear } from "../../admin/configuracion/BudgetResource/BudgetResourceForYear";
import { SelectBudgetSourceForYear } from "../../admin/configuracion/BudgetSource/SelectBudgetSourceForYear";
import { AdquisitionItemSelector } from "../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { PrintJson } from "../../theme/Component/PrintJson";
import { toast } from "react-toastify";

interface Props {
    formData: Record<string, any>;
    onChange: Function;
    props?: any;
    _AdquisitionItem?: any;
}

export const BudgetCDPFactoryValue = ({ onChange, formData, props, _AdquisitionItem }: Props) => {

    const { bean, setBean, lista, setLista, instance } = useDataBean(_BudgetSource);
    const _budget = useDataBean(_AdquisitionItemBudgetID);
    const [initBean, setInitBean] = useState<any>({});
    const [itemList, setItemList] = useState<any>([]);
    const [adquisitionItem, setAdquisitionItem] = useState<any>({
        ..._AdquisitionItem
    });

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalSource, setModalSource] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (props?.IDAdquisitionItem) {
            // getItem()
            if (props?.budgetList) {
                getBudgetItem()
            }
            else {
                getBudget()
            }
        }
    }, [props])

    const getBudget = () => {
        _budget.instance.getAdquisitionItemBudgetIDCatalog(props?.IDAdquisitionItem).then(
            (resp) => {
                processItems(resp);
                // setModalSource({ ...modal, "view": true, "name": "Seleccione la fuente de Recursos para cada articulo de la necesidad" })
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo cargar los rubros")
            }
        )
    }

    const getBudgetItem = () => {
        const x = props?.budgetList ? JSON.parse(props?.budgetList) : [];

        console.log(x)

        const isValidList = Array.isArray(x) && x.every(item =>
            item?.DataBeanProperties?.JsonCode &&
            item?.DataBeanProperties?.IDBudgetResource &&
            item?.DataBeanProperties?.IDBudgetSource
        );

        if (!isValidList) {
            getBudget();
        } else {
            // setItemList(x);
            // setModalSource({
                //     ...modal,
                //     "view": true,
                //     "name": "Seleccione la fuente de Recursos para cada artículo de la necesidad"
                // });
                processItems(x);
                // toast.info("Debe asignar una Fuente de recursos");
        }
    };


    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Saldo del Rubro', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor de la Apropiación', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Presupuesto', property: 'BudgetTypeName', visible: true },
        { title: 'Recurso Presupuestal', property: 'BudgetResourceName', visible: true },
        { title: 'Fuente de Financiamiento', property: 'BudgetSourceName', visible: true },
        { title: 'Referencia', property: 'Reference', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const modItem = () => {
        setBean({ ...bean, "IDBudgetResource": null, "IDBudgetSource": null });
        setModal({ ...modal, "view": true, "name": "Editar" })
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canCreate(), evento: () => { modItem() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { eliminarItem() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createItem = () => {
        setBean({});
        setInitBean({});
        setAdquisitionItem({ IDAdquisitionItem: props.IDAdquisitionItem })
        setModal({ ...modal, "view": true, "name": "Crear" })
    }

    const eliminarItem = () => {
        const updatedLista = lista.filter((bRow: any) =>
            JSON.stringify(bRow.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: props?.IDPIMP ? false : _single.canCreate(), icono: 'ri-file-add-line', evento: createItem }
    ]

    const createNewItem = () => {

        const updatedLista = lista.filter((bRow: any) =>
            JSON.stringify(bRow.DataBeanProperties) !== JSON.stringify(initBean)
        );

        instance.createBudgetRowCDPItem(formData.Date, formData.BudgetIDType, bean.BudgetIDStr, bean.IDBudgetResource, bean.IDBudgetSource, bean.Value, bean.Description, adquisitionItem.IDAdquisitionItem ?? null, adquisitionItem?.CodeItem ?? null, false).then(
            (resp: any) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => toast.error(err)
        )
    }

    const processItems = async (itemDirectList?: any) => {
        setLista([]);
        _single.spinner(true);
        const list = itemDirectList ?? itemList;
        const errors: string[] = [];

        const promises = list.map((obj: any) => {
            return instance.createBudgetRowCDPItem(
                formData.Date,
                formData.BudgetIDType,
                obj.DataBeanProperties.JsonCode,
                obj.DataBeanProperties.IDBudgetResource,
                obj.DataBeanProperties.IDBudgetSource,
                obj.DataBeanProperties.EstimatedValue,
                `Creado el ${_single.getCurrenDate()}`,
                adquisitionItem.IDAdquisitionItem,
                adquisitionItem.CodeItem ?? null,
                true
            )
                .then((resp: any) => {
                    setLista(prevLista => [
                        ...prevLista,
                        {
                            DataBeanProperties: resp,
                            DataBeanName: 'budget.Budget',
                        },
                    ]);
                })
                .catch(() => {
                    errors.push(`Error con item ${obj.DataBeanProperties.JsonCode}`);
                    // No mostramos el error aquí, solo lo registramos
                });
        });

        await Promise.all(promises);
        _single.spinner(false);

        if (errors.length === 0) {
            toast.success("Todos los ítems fueron procesados correctamente");
            setModalSource({ ...modalSource, view: false });
        } else {
            // Solo mostramos un único error general
            // toast.error("Algunos ítems fallaron. Revisa la consola para más detalles.");
            console.error("Errores al procesar ítems:", errors);
        }
    };





    const setRowBean = (object: any) => {
        setBean(object);
        setInitBean(object)
    }

    useEffect(() => {
        onChange(lista);
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={(e) => { setRowBean(e) }} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={createNewItem} >
                    <div className="row">
                        <>
                            <div className="col-md-12">
                                <SelectBudgetID onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode }) }} jsonCode={bean.BudgetIDStr} edit={false} />
                            </div>
                            {bean.BudgetIDStr &&
                                <div className="col-md-12">
                                    <SelectBudgetResourceForYear config={{
                                        date: formData.Date,
                                        budget: bean.BudgetIDStr,
                                    }} idSelector={bean.IDBudgetResource} onChange={(e) => { setBean({ ...bean, "IDBudgetResource": e }) }} />
                                </div>
                            }
                            {bean.IDBudgetResource &&
                                <div className="col-md-12">
                                    <SelectBudgetSourceForYear idSelector={bean.IDBudgetSource} onChange={(e) => { setBean({ ...bean, "IDBudgetSource": e }) }} cProps={{
                                        budgetIDSTr: bean.BudgetIDStr,
                                        budgetResource: bean.IDBudgetResource,
                                        date: formData.Date,
                                    }} />
                                </div>
                            }
                            <div className="col-md-12">
                                <InputMoney _label='Valor de la Apropiación' _value={bean.Value} onChange={(e: any) => { setBean({ ...bean, 'Value': e }) }} />
                            </div>
                        </>
                        <hr className="mt-3" />
                        <div className="col-md-12">
                            <AdquisitionItemSelector listStates={[6,43]} idAdquisitionItem={adquisitionItem.IDAdquisitionItem} onChage={(e) => { setAdquisitionItem(e) }} ConfigProps={{ label: "Necesidad Seleccionada", notSeeProps: true }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalSource} updateModal={setModalSource} eventModal={() => {
                    const allHaveIDBudgetSource = itemList.every(
                        (item) => item.DataBeanProperties.IDBudgetSource
                    );

                    if (!allHaveIDBudgetSource) {
                        toast.error("Todos los elementos deben tener una fuente de financiamiento seleccionada.");
                        return;
                    }
                    processItems();
                }} >
                    <div className="row">
                        {/* <PrintJson json={itemList} /> */}
                        {itemList.length > 0 &&
                            <div className="col-md-12">
                                {itemList.map((necesidad: any, index: number) => {
                                    return (
                                        <div key={index} className="row">
                                            <div className="col-md-12">
                                                <b>{index + 1} Rubro Afectado: {necesidad.DataBeanProperties.IDLnBudgetIDName}</b>
                                                <SelectBudgetSourceForYear
                                                    idSelector={necesidad.DataBeanProperties.IDBudgetSource}
                                                    onChange={(e) => {
                                                        const updatedList = itemList.map((item, idx) => {
                                                            if (idx === index) {
                                                                return {
                                                                    ...item,
                                                                    DataBeanProperties: {
                                                                        ...item.DataBeanProperties,
                                                                        IDBudgetSource: e,
                                                                    },
                                                                };
                                                            }
                                                            return item;
                                                        });
                                                        setItemList(updatedList);
                                                    }}
                                                    cProps={{
                                                        budgetIDSTr: necesidad.DataBeanProperties.JsonCode,
                                                        budgetResource: necesidad.DataBeanProperties.IDBudgetResource,
                                                        date: formData.Date,
                                                    }}
                                                />
                                                <hr />
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        }
                    </div>
                </Modal>
            </div>
        </div>
    )
}